import script from "./VoucherSavingSuggestions.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherSavingSuggestions.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherSavingSuggestions.vue?vue&type=style&index=0&id=962e9956&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-962e9956"]])

export default __exports__